import { LMFeature } from "@livingmap/core-mapping";

import { Feature } from "../redux/services/config";
import { GeoJSONFeature } from "mapbox-gl";
import { SourceIds } from "components/Map/plugins/types";

interface EnhancedFeature extends Feature {
  state: {};
  layer: {
    id: string;
    type: string;
    source: string; // Add required properties as per ClipLayerSpecification or other required types
    // Include any additional properties required by the layer specifications
  };
  clone: () => GeoJSONFeature;
  toJSON: () => Feature;
}

export const createLMFeatures = (features: Feature[]) => {
  return features.map((feature) => {
    const enhancedFeature = {
      ...feature,
      state: {},
      layer: { ...feature.layer, source: "requiredSource" },
    } as EnhancedFeature;

    // If further adjustments or validations are needed, ensure they are done before instantiation
    return new LMFeature(enhancedFeature as GeoJSONFeature);
  });
};

export const enhanceLMFeature = (
  feature: LMFeature,
  apiFeature: Feature,
): LMFeature => {
  const mapboxFeature = feature.getMapboxFeature();

  // If no area_highlight then return the original feature
  if (!apiFeature.properties?.area_highlight) {
    return feature;
  }

  const enhancedFeature = {
    ...mapboxFeature,
    properties: {
      ...mapboxFeature.properties,
      area_highlight:
        new LMFeature({
          ...apiFeature.properties?.area_highlight,
          layer: {
            id: "custom",
            type: "symbol",
            source: SourceIds.LM_SOURCE_ID, // Correctly define the source here
          },
          state: {},
          source: SourceIds.LM_SOURCE_ID,
          sourceLayer: mapboxFeature.sourceLayer,
        } as GeoJSONFeature) || null,
    },
  };

  return new LMFeature(enhancedFeature);
};
